import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=5ced8a62&"
import script from "./UserActivity.vue?vue&type=script&lang=js&"
export * from "./UserActivity.vue?vue&type=script&lang=js&"
import style0 from "./UserActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ced8a62')) {
      api.createRecord('5ced8a62', component.options)
    } else {
      api.reload('5ced8a62', component.options)
    }
    module.hot.accept("./UserActivity.vue?vue&type=template&id=5ced8a62&", function () {
      api.rerender('5ced8a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History/UserActivity.vue"
export default component.exports